export const imageTiming = (scope, id, enabled = false) => {
  const started = performance.now();
  const stages = {};
  return {
    async measure(stage, callback) {
      const started = performance.now();
      try {
        return await callback();
      } finally {
        stages[stage] = (stages[stage] || 0) + performance.now() - started;
      }
    },
    finish(outcome = "done") {
      if (!enabled) return;
      console.info(
        "[image-timing]",
        JSON.stringify({
          scope,
          id,
          outcome,
          ms: Object.fromEntries(Object.entries(stages).map(([stage, duration]) => [stage, Math.round(duration)])),
          totalMs: Math.round(performance.now() - started),
        }),
      );
    },
  };
};
